export default "__VITE_ASSET__DxTRVEzR__"